<script setup lang="ts">
import { inject } from 'vue';

import { emptyFunc } from '@/utils/funcs';
import KSwitchField from '@/components/fields/KSwitchField.vue';
import { noticesToggleReadFilterKey } from '@/constants/injectionKeys';

export interface Props {
  isSwitchDisabled?: boolean;
  isReadFilter?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  isSwitchDisabled: false,
  isReadFilter: false,
});

const toggleReadFilter = inject(noticesToggleReadFilterKey, emptyFunc);
</script>

<template>
  <header :class="$style.noticesHeader" data-testid="noticesHeader">
    <div :class="$style.headerLeftItem">
      <h4 :class="$style.h4">Notifications</h4>
    </div>
    <div :class="$style.headerRightItem">
      <KSwitchField
        :model-value="props.isReadFilter"
        :disabled="props.isSwitchDisabled"
        label="Show unread only"
        hide-details
        inset
        is-label-first
        priority="info"
        @update:model-value="toggleReadFilter"
      />
    </div>
  </header>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.noticesHeader {
  background-color: colors.$color-brand-50;
  display: flex;
  height: 65px;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
}
  .headerLeftItem {
  }
    .h4 {
      margin: 0;
      font-size: 1.5rem;
      font-weight: 500;
    }
  .headerRightItem {
  }
</style>
